import script from "./ProductAttributeGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductAttributeGroup.vue?vue&type=script&setup=true&lang=ts"

import "./ProductAttributeGroup.vue?vue&type=style&index=0&id=7e9f0087&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9f0087"]])

export default __exports__